import firebase from "firebase";
export const getVouchers = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("vouchers")
    .onSnapshot((query) => {
      var tempVouchers = [];
      query.docs.forEach((voucher) => {
        tempVouchers.push({ id: voucher.id, ...voucher.data() });
      });
      dispatch({
        type: "GET_VOUCHERS",
        vouchers: tempVouchers,
      });
    });
};
